export const FAQWording = [
  {
    id: 1,
    question: '¿Qué es Waynimóvil?',
    answer: (
      <>
        <p>
          Waynimóvil es una fintech de créditos 100% online con la que podés
          pedir el préstamo que necesitás sin tener que ir al banco ni realizar
          trámites extensos.
        </p>
        <p>
          Si querés conocer más sobre nosotros, visitá el artículo que subimos a
          nuestro{' '}
          <a
            className='font-bold underline'
            href='https://blog.waynimovil.com/waynimovil/te-damos-la-bienvenida-al-blog-de-waynimovil?utm_source=comunicacion&utm_medium=Zendesk&utm_campaign=requisitos'
            target='_blank'
            rel='noreferrer'
          >
            Blog sobre el tema
          </a>
          .
        </p>
      </>
    )
  },
  {
    id: 2,
    question: '¿Dónde opera Waynimóvil?',
    answer: (
      <>
        <p>
          Waynimóvil opera en todo el territorio de la República Argentina y
          Uruguaya.
        </p>
        <p>Otorga préstamos en pesos argentinos y uruguayos.</p>
      </>
    )
  },
  {
    id: 3,
    question: '¿Cómo cancelo un préstamo?',
    answer: (
      <>
        <p>
          Podés cancelar un préstamo siempre y cuando no hayan pasado más de 10
          días hábiles desde el momento en que recibiste los fondos.
        </p>
        <p>
          Para proceder con la cancelación tenés que devolver los fondos que
          recibiste.{' '}
          <a
            className='font-bold underline'
            href='https://ayuda.waynimovil.com/hc/es-419/articles/4403307634715--C%C3%B3mo-cancelo-el-pr%C3%A9stamo-que-solicit%C3%A9'
            target='_blank'
            rel='noreferrer'
          >
            Accedé al instructivo
          </a>
          .
        </p>
      </>
    )
  },
  {
    id: 4,
    question: '¿Qué es el VERAZ y cómo me afecta?',
    answer:
      'El Veraz es un sistema compuesto por una base de datos que recopila información sobre la capacidad crediticia y de solvencia económica de una persona. Esta base de datos es la que informa si hay personas morosas o con deudas con alguna empresa de crédito, de servicios o bancos.'
  },
  {
    id: 5,
    question: '¿Por qué me piden los datos de mi tarjeta de débito?',
    answer: (
      <>
        <p>
          Aunque en Waynimóvil ofrecemos varios métodos de pago, nuestra
          principal forma de cobro es a través del débito automático. Esta
          modalidad simplifica muchísimo el pago de las cuotas de tu préstamo,
          evitándote perder tiempo en largas colas o pagando en efectivo.
        </p>
        <p>
          Para saber más sobre el tema 👉{' '}
          <a
            className='font-bold underline'
            href='https://ayuda.waynimovil.com/hc/es-419/articles/4402108082075--Por-qu%C3%A9-me-piden-los-datos-de-mi-tarjeta-de-d%C3%A9bito'
            target='_blank'
            rel='noreferrer'
          >
            clic aquí
          </a>
          .
        </p>
      </>
    )
  },
  {
    id: 6,
    question: '¿Por qué me piden una selfie con el DNI?',
    answer:
      'Poder tener una fotografía de tu documento nacional de identidad, y una selfie donde podamos verificar que sos el verdadero portador de ese DNI, es fundamental para evitar que otras personas puedan usar tus datos para pedir préstamos en tu nombre, endeudándote sin que siquiera lo sepas.'
  },
  {
    id: 7,
    question: '¿Qué es el CBU y cómo lo obtengo?',
    answer: (
      <>
        <p>
          La Clave Bancaria Uniforme es un código de identificación bancario
          compuesto por 22 dígitos que sirve para que puedas realizar
          transferencias de dinero entre distintas cuentas.
        </p>
        <a
          className='font-bold underline'
          href='https://ayuda.waynimovil.com/hc/es-419/articles/4402108074651--Qu%C3%A9-es-el-n%C3%BAmero-de-CBU-y-c%C3%B3mo-lo-obtengo'
          target='_blank'
          rel='noreferrer'
        >
          Accedé al instructivo.
        </a>
      </>
    )
  },
  {
    id: 8,
    question:
      '¿Puedo solicitar un préstamo si cobro alguna de las prestaciones de ANSES?',
    answer:
      'Sí. Una vez que completes tu solicitud, nuestro sistema determinará si podemos darte un préstamo y el monto.'
  },
  {
    id: 9,
    question: 'Si mi préstamo fue rechazado, ¿puedo volver a intentarlo?',
    answer: (
      <>
        <p>
          Sí, aunque deberás esperar 30 días para eso. Los rechazos se producen
          a causa de inconvenientes en la verificación crediticia, que pueden
          variar con el tiempo.
        </p>
        <p>
          Por eso, es posible que, aunque se te haya denegado en un principio,
          se te otorgue un préstamo Waynimóvil en un segundo intento :)
        </p>
      </>
    )
  }
]
